import React from 'react';
import Tooltip from 'src/components/tooltip';
/**
 * @deprecated Use FormikCredentialsInput with prop signup and see password requirements as text below
 */
const PasswordInstructionsTooltip = (props: {children}) => (
  <Tooltip
    title={
      <>
        Password must include:
        <ul>
          <li>At least 8 characters</li>
          <li>At least 1 uppercase letter</li>
          <li>At least 1 lowercase letter</li>
          <li>At least 1 number</li>
        </ul>
      </>
    }
  >
    {props.children}
  </Tooltip>
);

export default PasswordInstructionsTooltip;
